import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    // Kompaktne tabele u cijeloj aplikaciji (manji vertikalni padding ćelija)
    MuiTable: {
      defaultProps: {
        size: 'small',
      },
    },

    // Zebrasti redovi: svaki drugi red blago pijesak-smeđi (nijansa zaglavlja, ali mnogo svjetlija)
    MuiTableBody: {
      styleOverrides: {
        root: {
          '& .MuiTableRow-root:nth-of-type(even)': {
            backgroundColor: alpha(theme.palette.background.neutral, 0.45),
          },
          // Hover mora biti iza zebre, inače se na parnim redovima ne bi vidio
          '& .MuiTableRow-hover:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          // Izabrani red (npr. izabrani accountant na Uplatama) ostaje istaknut i na parnim redovima
          '& .MuiTableRow-root.Mui-selected, & .MuiTableRow-root.Mui-selected:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.14),
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}